// Health checks shown before any result: split, exposures, one variant per
// player, sample size and run time. Each has an icon and a word, never a
// colour alone.
import React from 'react';
import { Alert, List, Space, Typography } from 'antd';
import {
  CheckCircleFilled,
  ClockCircleOutlined,
  CloseCircleFilled,
  ExclamationCircleFilled,
} from '@ant-design/icons';
import type { CheckStatus, HealthCheck, Recommendation } from './results';

const STATUS: Record<CheckStatus, { icon: React.ReactNode; word: string }> = {
  pass: { icon: <CheckCircleFilled style={{ color: '#0ca30c' }} />, word: 'OK' },
  warn: { icon: <ExclamationCircleFilled style={{ color: '#d48806' }} />, word: 'Check' },
  fail: { icon: <CloseCircleFilled style={{ color: '#d03b3b' }} />, word: 'Problem' },
  pending: { icon: <ClockCircleOutlined style={{ color: '#8c8c8c' }} />, word: 'Waiting' },
};

export const HealthChecks: React.FC<{ checks: HealthCheck[] }> = ({ checks }) => (
  <List
    size="small"
    bordered
    dataSource={checks}
    renderItem={(c) => (
      <List.Item data-check={c.key} data-status={c.status}>
        <Space align="start">
          {STATUS[c.status].icon}
          <Space direction="vertical" size={0}>
            <Typography.Text strong>
              {c.label}{' '}
              <Typography.Text type="secondary">· {STATUS[c.status].word}</Typography.Text>
            </Typography.Text>
            <Typography.Text type="secondary">{c.detail}</Typography.Text>
          </Space>
        </Space>
      </List.Item>
    )}
  />
);

export const RecommendationBanner: React.FC<{ value: Recommendation | null }> = ({ value }) =>
  value ? (
    <Alert
      type={value.type}
      showIcon
      message={<Typography.Text strong>{value.title}</Typography.Text>}
      description={value.detail}
    />
  ) : null;
